import { render, staticRenderFns } from "./DeactivatedNotification.vue?vue&type=template&id=5e35ab5f&"
import script from "./DeactivatedNotification.vue?vue&type=script&lang=js&"
export * from "./DeactivatedNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/branch.goz.fun/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e35ab5f')) {
      api.createRecord('5e35ab5f', component.options)
    } else {
      api.reload('5e35ab5f', component.options)
    }
    module.hot.accept("./DeactivatedNotification.vue?vue&type=template&id=5e35ab5f&", function () {
      api.rerender('5e35ab5f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Views/DeactivatedNotification.vue"
export default component.exports